// src/modules/app-views/goodsReceipt/pages/Init/components/tableColumns/issuerColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import { parseCnpjToDisplay } from 'utils/helpers';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
// Renders issuer (supplier) name with CNPJ subtitle.
// Reads issuer.tradeName || issuer.name as primary display, issuer.cnpj as subtitle.
function issuerColumn(buildColumnProps, options = {}) {
  return {
    title: translateX('issuer'),
    dataIndex: ['issuer', 'name'],
    ...buildColumnProps('issuer.name', {
      sort: true,
      search: true,
      searchPlaceholder: 'issuer',
    }),
    ellipsis: true,
    render: (_, record) => {
      const issuer = record?.issuer;
      const name = issuer?.tradeName || issuer?.name;
        const cnpj = issuer?.cpfCnpj;

      const cnpjDisplay = cnpj ? parseCnpjToDisplay(cnpj) : null;

      if (!name) return <Text type="secondary">—</Text>;

      return (
        <div>
          <Text ellipsis strong style={{ display: 'block' }}>
            {name}
          </Text>
          {cnpjDisplay && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              CNPJ: {cnpjDisplay}
            </Text>
          )}
        </div>
      );
    },
  };
}

export default issuerColumn;
